// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-on-duty-page {
    padding: 20px;
    min-height: 100vh;
    transition: background-color 0.3s, color 0.3s;
  }
  
  .users-on-duty-page.dark-theme {
    background-color: #1a1a1a;
    color: #ffffff;
  }
  
  .users-on-duty-page.light-theme {
    background-color: #f5f5f5;
    color: #333333;
  }
  
  .page-header {
    margin-bottom: 30px;
    text-align: center;
  }
  
  .page-header h1 {
    font-size: 2.5rem;
    margin-bottom: 10px;
    color: inherit;
  }
  
  .page-subtitle {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 20px;
  }
  
  .dark-theme .page-subtitle {
    color: #aaa;
  }
  
  .summary-stats {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;
    flex-wrap: wrap;
  }
  
  .stat-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    min-width: 180px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
  }
  
  .dark-theme .stat-card {
    background: #2d2d2d;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  }
  
  .stat-card:hover {
    transform: translateY(-2px);
  }
  
  .stat-value {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 10px;
    color: #2196f3;
  }
  
  .dark-theme .stat-value {
    color: #64b5f6;
  }
  
  .stat-label {
    font-size: 0.9rem;
    color: #666;
  }
  
  .dark-theme .stat-label {
    color: #aaa;
  }
  
  .roles-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 25px;
    margin-bottom: 40px;
  }
  
  .role-column {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s;
  }
  
  .dark-theme .role-column {
    background: #2d2d2d;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  }
  
  .role-column:hover {
    transform: translateY(-5px);
  }
  
  .role-header {
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }
  
  .role-header.coordinator {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  }
  
  .role-header.mentor {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  }
  
  .role-header.duty-task {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  }
  
  .role-header.duty-chat {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  }
  
  .role-header.teamlead {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .role-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .role-icon {
    font-size: 1.5rem;
  }
  
  .role-header h3 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
  }
  
  .role-description {
    font-size: 0.9rem;
    opacity: 0.9;
    margin-bottom: 10px;
  }
  
  .user-count {
    font-size: 0.8rem;
    opacity: 0.8;
  }
  
  .users-list {
    padding: 20px;
    max-height: 400px;
    overflow-y: auto;
  }
  
  .user-card {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    transition: all 0.3s;
    border-left: 4px solid #2196f3;
  }
  
  .dark-theme .user-card {
    background: #3d3d3d;
  }
  
  .user-card:hover {
    background: #e9ecef;
    transform: translateX(5px);
  }
  
  .dark-theme .user-card:hover {
    background: #4d4d4d;
  }
  
  .user-info {
    margin-bottom: 10px;
  }
  
  .user-name {
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 5px;
    color: inherit;
  }
  
  .user-id {
    font-size: 0.8rem;
    color: #666;
    font-family: monospace;
  }
  
  .dark-theme .user-id {
    color: #aaa;
  }
  
  .user-roles {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .role-badge {
    font-size: 0.7rem;
    padding: 4px 8px;
    border-radius: 12px;
    background: rgba(33, 150, 243, 0.1);
    color: #2196f3;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  .role-badge.coordinator {
    background: rgba(240, 147, 251, 0.1);
    color: #f093fb;
  }
  
  .role-badge.mentor {
    background: rgba(79, 172, 254, 0.1);
    color: #4facfe;
  }
  
  .role-badge.duty-task {
    background: rgba(67, 233, 123, 0.1);
    color: #43e97b;
  }
  
  .role-badge.duty-chat {
    background: rgba(250, 112, 154, 0.1);
    color: #fa709a;
  }
  
  .role-badge.teamlead {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
  }
  
  .no-users-message {
    text-align: center;
    padding: 30px;
    color: #666;
    font-style: italic;
  }
  
  .dark-theme .no-users-message {
    color: #aaa;
  }
  
  .all-users-section {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 2px solid #e0e0e0;
  }
  
  .dark-theme .all-users-section {
    border-top-color: #444;
  }
  
  .all-users-section h2 {
    text-align: center;
    margin-bottom: 20px;
    color: inherit;
  }
  
  .all-users-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .loading, .error {
    text-align: center;
    padding: 50px;
    font-size: 1.2rem;
  }
  
  .error {
    color: #f44336;
  }
  
  .dark-theme .error {
    color: #ef5350;
  }
  
  /* Responsive design */
  @media (max-width: 1200px) {
    .roles-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  
  @media (max-width: 768px) {
    .roles-grid {
      grid-template-columns: 1fr;
    }
    
    .summary-stats {
      flex-direction: column;
      align-items: center;
    }
    
    .stat-card {
      width: 100%;
      max-width: 300px;
    }
    
    .all-users-grid {
      grid-template-columns: 1fr;
    }
  }

  .user-card-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .user-main-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .user-name {
    font-weight: 600;
    font-size: 1.1rem;
    color: inherit;
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .user-roles-inline {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
  }
  
  .role-badge-small {
    font-size: 0.9rem;
    padding: 4px 6px;
    border-radius: 6px;
    background: rgba(33, 150, 243, 0.1);
    color: #2196f3;
    min-width: 30px;
    text-align: center;
  }
  
  .role-badge-small.coordinator {
    background: rgba(240, 147, 251, 0.1);
    color: #f093fb;
  }
  
  .role-badge-small.mentor {
    background: rgba(79, 172, 254, 0.1);
    color: #4facfe;
  }
  
  .role-badge-small.duty-task {
    background: rgba(67, 233, 123, 0.1);
    color: #43e97b;
  }
  
  .role-badge-small.duty-chat {
    background: rgba(250, 112, 154, 0.1);
    color: #fa709a;
  }
  
  .role-badge-small.teamlead {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
  }
  
  .user-roles-full {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    display: none; /* Приховано на мобільних */
  }
  
  /* Адаптивність */
  @media (min-width: 768px) {
    .user-card-content {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 15px;
    }
    
    .user-main-info {
      flex: 1 1;
      justify-content: flex-start;
      gap: 15px;
    }
    
    .user-roles-inline {
      display: none; /* Приховано на великих екранах */
    }
    
    .user-roles-full {
      display: flex; /* Показано на великих екранах */
      flex-shrink: 0;
    }
  }
  
  /* Для дуже маленьких екранів */
  @media (max-width: 400px) {
    .user-main-info {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
    
    .user-roles-inline {
      align-self: flex-start;
    }
  }
  
  .user-card {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
    transition: all 0.3s;
    border-left: 4px solid #2196f3;
  }
  
  .dark-theme .user-card {
    background: #3d3d3d;
  }
  
  .user-card:hover {
    background: #e9ecef;
    transform: translateX(5px);
  }
  
  .dark-theme .user-card:hover {
    background: #4d4d4d;
  }
  
  .role-badge {
    font-size: 0.7rem;
    padding: 4px 8px;
    border-radius: 12px;
    background: rgba(33, 150, 243, 0.1);
    color: #2196f3;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  .role-badge.coordinator {
    background: rgba(240, 147, 251, 0.1);
    color: #f093fb;
  }
  
  .role-badge.mentor {
    background: rgba(79, 172, 254, 0.1);
    color: #4facfe;
  }
  
  .role-badge.duty-task {
    background: rgba(67, 233, 123, 0.1);
    color: #43e97b;
  }
  
  .role-badge.duty-chat {
    background: rgba(250, 112, 154, 0.1);
    color: #fa709a;
  }
  
  .role-badge.teamlead {
    background: rgba(102, 126, 234, 0.1);
    color: #667eea;
  }`, "",{"version":3,"sources":["webpack://./src/components/covfile/DutyPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,6DAA6D;IAC7D,YAAY;EACd;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mCAAmC;IACnC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,sBAAsB;EACtB;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,aAAa,EAAE,2BAA2B;EAC5C;;EAEA,iBAAiB;EACjB;IACE;MACE,mBAAmB;MACnB,8BAA8B;MAC9B,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,SAAO;MACP,2BAA2B;MAC3B,SAAS;IACX;;IAEA;MACE,aAAa,EAAE,iCAAiC;IAClD;;IAEA;MACE,aAAa,EAAE,gCAAgC;MAC/C,cAAc;IAChB;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;IACV;;IAEA;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mCAAmC;IACnC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;EAChB","sourcesContent":[".users-on-duty-page {\r\n    padding: 20px;\r\n    min-height: 100vh;\r\n    transition: background-color 0.3s, color 0.3s;\r\n  }\r\n  \r\n  .users-on-duty-page.dark-theme {\r\n    background-color: #1a1a1a;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  .users-on-duty-page.light-theme {\r\n    background-color: #f5f5f5;\r\n    color: #333333;\r\n  }\r\n  \r\n  .page-header {\r\n    margin-bottom: 30px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .page-header h1 {\r\n    font-size: 2.5rem;\r\n    margin-bottom: 10px;\r\n    color: inherit;\r\n  }\r\n  \r\n  .page-subtitle {\r\n    font-size: 1.1rem;\r\n    color: #666;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .dark-theme .page-subtitle {\r\n    color: #aaa;\r\n  }\r\n  \r\n  .summary-stats {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    margin-bottom: 30px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .stat-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    min-width: 180px;\r\n    text-align: center;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s;\r\n  }\r\n  \r\n  .dark-theme .stat-card {\r\n    background: #2d2d2d;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  .stat-card:hover {\r\n    transform: translateY(-2px);\r\n  }\r\n  \r\n  .stat-value {\r\n    font-size: 2.5rem;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n    color: #2196f3;\r\n  }\r\n  \r\n  .dark-theme .stat-value {\r\n    color: #64b5f6;\r\n  }\r\n  \r\n  .stat-label {\r\n    font-size: 0.9rem;\r\n    color: #666;\r\n  }\r\n  \r\n  .dark-theme .stat-label {\r\n    color: #aaa;\r\n  }\r\n  \r\n  .roles-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n    gap: 25px;\r\n    margin-bottom: 40px;\r\n  }\r\n  \r\n  .role-column {\r\n    background: white;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.3s;\r\n  }\r\n  \r\n  .dark-theme .role-column {\r\n    background: #2d2d2d;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\r\n  }\r\n  \r\n  .role-column:hover {\r\n    transform: translateY(-5px);\r\n  }\r\n  \r\n  .role-header {\r\n    padding: 20px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n  }\r\n  \r\n  .role-header.coordinator {\r\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\r\n  }\r\n  \r\n  .role-header.mentor {\r\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\r\n  }\r\n  \r\n  .role-header.duty-task {\r\n    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\r\n  }\r\n  \r\n  .role-header.duty-chat {\r\n    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\r\n  }\r\n  \r\n  .role-header.teamlead {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  }\r\n  \r\n  .role-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .role-icon {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .role-header h3 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .role-description {\r\n    font-size: 0.9rem;\r\n    opacity: 0.9;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .user-count {\r\n    font-size: 0.8rem;\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  .users-list {\r\n    padding: 20px;\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .user-card {\r\n    background: #f8f9fa;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 15px;\r\n    transition: all 0.3s;\r\n    border-left: 4px solid #2196f3;\r\n  }\r\n  \r\n  .dark-theme .user-card {\r\n    background: #3d3d3d;\r\n  }\r\n  \r\n  .user-card:hover {\r\n    background: #e9ecef;\r\n    transform: translateX(5px);\r\n  }\r\n  \r\n  .dark-theme .user-card:hover {\r\n    background: #4d4d4d;\r\n  }\r\n  \r\n  .user-info {\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .user-name {\r\n    font-weight: 600;\r\n    font-size: 1.1rem;\r\n    margin-bottom: 5px;\r\n    color: inherit;\r\n  }\r\n  \r\n  .user-id {\r\n    font-size: 0.8rem;\r\n    color: #666;\r\n    font-family: monospace;\r\n  }\r\n  \r\n  .dark-theme .user-id {\r\n    color: #aaa;\r\n  }\r\n  \r\n  .user-roles {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .role-badge {\r\n    font-size: 0.7rem;\r\n    padding: 4px 8px;\r\n    border-radius: 12px;\r\n    background: rgba(33, 150, 243, 0.1);\r\n    color: #2196f3;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .role-badge.coordinator {\r\n    background: rgba(240, 147, 251, 0.1);\r\n    color: #f093fb;\r\n  }\r\n  \r\n  .role-badge.mentor {\r\n    background: rgba(79, 172, 254, 0.1);\r\n    color: #4facfe;\r\n  }\r\n  \r\n  .role-badge.duty-task {\r\n    background: rgba(67, 233, 123, 0.1);\r\n    color: #43e97b;\r\n  }\r\n  \r\n  .role-badge.duty-chat {\r\n    background: rgba(250, 112, 154, 0.1);\r\n    color: #fa709a;\r\n  }\r\n  \r\n  .role-badge.teamlead {\r\n    background: rgba(102, 126, 234, 0.1);\r\n    color: #667eea;\r\n  }\r\n  \r\n  .no-users-message {\r\n    text-align: center;\r\n    padding: 30px;\r\n    color: #666;\r\n    font-style: italic;\r\n  }\r\n  \r\n  .dark-theme .no-users-message {\r\n    color: #aaa;\r\n  }\r\n  \r\n  .all-users-section {\r\n    margin-top: 40px;\r\n    padding-top: 20px;\r\n    border-top: 2px solid #e0e0e0;\r\n  }\r\n  \r\n  .dark-theme .all-users-section {\r\n    border-top-color: #444;\r\n  }\r\n  \r\n  .all-users-section h2 {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    color: inherit;\r\n  }\r\n  \r\n  .all-users-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n    gap: 20px;\r\n  }\r\n  \r\n  .loading, .error {\r\n    text-align: center;\r\n    padding: 50px;\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .error {\r\n    color: #f44336;\r\n  }\r\n  \r\n  .dark-theme .error {\r\n    color: #ef5350;\r\n  }\r\n  \r\n  /* Responsive design */\r\n  @media (max-width: 1200px) {\r\n    .roles-grid {\r\n      grid-template-columns: repeat(2, 1fr);\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .roles-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n    \r\n    .summary-stats {\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n    \r\n    .stat-card {\r\n      width: 100%;\r\n      max-width: 300px;\r\n    }\r\n    \r\n    .all-users-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  .user-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .user-main-info {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .user-name {\r\n    font-weight: 600;\r\n    font-size: 1.1rem;\r\n    color: inherit;\r\n    flex-shrink: 1;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .user-roles-inline {\r\n    display: flex;\r\n    gap: 6px;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .role-badge-small {\r\n    font-size: 0.9rem;\r\n    padding: 4px 6px;\r\n    border-radius: 6px;\r\n    background: rgba(33, 150, 243, 0.1);\r\n    color: #2196f3;\r\n    min-width: 30px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .role-badge-small.coordinator {\r\n    background: rgba(240, 147, 251, 0.1);\r\n    color: #f093fb;\r\n  }\r\n  \r\n  .role-badge-small.mentor {\r\n    background: rgba(79, 172, 254, 0.1);\r\n    color: #4facfe;\r\n  }\r\n  \r\n  .role-badge-small.duty-task {\r\n    background: rgba(67, 233, 123, 0.1);\r\n    color: #43e97b;\r\n  }\r\n  \r\n  .role-badge-small.duty-chat {\r\n    background: rgba(250, 112, 154, 0.1);\r\n    color: #fa709a;\r\n  }\r\n  \r\n  .role-badge-small.teamlead {\r\n    background: rgba(102, 126, 234, 0.1);\r\n    color: #667eea;\r\n  }\r\n  \r\n  .user-roles-full {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n    display: none; /* Приховано на мобільних */\r\n  }\r\n  \r\n  /* Адаптивність */\r\n  @media (min-width: 768px) {\r\n    .user-card-content {\r\n      flex-direction: row;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      gap: 15px;\r\n    }\r\n    \r\n    .user-main-info {\r\n      flex: 1;\r\n      justify-content: flex-start;\r\n      gap: 15px;\r\n    }\r\n    \r\n    .user-roles-inline {\r\n      display: none; /* Приховано на великих екранах */\r\n    }\r\n    \r\n    .user-roles-full {\r\n      display: flex; /* Показано на великих екранах */\r\n      flex-shrink: 0;\r\n    }\r\n  }\r\n  \r\n  /* Для дуже маленьких екранів */\r\n  @media (max-width: 400px) {\r\n    .user-main-info {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 8px;\r\n    }\r\n    \r\n    .user-roles-inline {\r\n      align-self: flex-start;\r\n    }\r\n  }\r\n  \r\n  .user-card {\r\n    background: #f8f9fa;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 15px;\r\n    transition: all 0.3s;\r\n    border-left: 4px solid #2196f3;\r\n  }\r\n  \r\n  .dark-theme .user-card {\r\n    background: #3d3d3d;\r\n  }\r\n  \r\n  .user-card:hover {\r\n    background: #e9ecef;\r\n    transform: translateX(5px);\r\n  }\r\n  \r\n  .dark-theme .user-card:hover {\r\n    background: #4d4d4d;\r\n  }\r\n  \r\n  .role-badge {\r\n    font-size: 0.7rem;\r\n    padding: 4px 8px;\r\n    border-radius: 12px;\r\n    background: rgba(33, 150, 243, 0.1);\r\n    color: #2196f3;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .role-badge.coordinator {\r\n    background: rgba(240, 147, 251, 0.1);\r\n    color: #f093fb;\r\n  }\r\n  \r\n  .role-badge.mentor {\r\n    background: rgba(79, 172, 254, 0.1);\r\n    color: #4facfe;\r\n  }\r\n  \r\n  .role-badge.duty-task {\r\n    background: rgba(67, 233, 123, 0.1);\r\n    color: #43e97b;\r\n  }\r\n  \r\n  .role-badge.duty-chat {\r\n    background: rgba(250, 112, 154, 0.1);\r\n    color: #fa709a;\r\n  }\r\n  \r\n  .role-badge.teamlead {\r\n    background: rgba(102, 126, 234, 0.1);\r\n    color: #667eea;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
